import { userState } from '../../../stores/user';

/** 打开登录浮层（独立文件，避免经 utils/common 拉进无关共享 chunk） */
export const gotoLogin = () => {
  userState.showLoginPage = true;
};
